import { render, staticRenderFns } from "./IdentificationPatient.vue?vue&type=template&id=4b47df51&scoped=true"
import script from "./IdentificationPatient.vue?vue&type=script&lang=js"
export * from "./IdentificationPatient.vue?vue&type=script&lang=js"
import style0 from "./IdentificationPatient.vue?vue&type=style&index=0&id=4b47df51&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b47df51",
  null
  
)

export default component.exports